import React from "react"
import glamorous from "glamorous"
import style from "utils/style"

export default ({ error, ...props }) =>
  error ? <Error {...props}>{error}</Error> : null

const Error = glamorous.div(
  {
    color: "red",
    paddingBottom: "0.5rem",
  },
  ({ inline }) => ({
    marginLeft: inline && "25%",
    [style.size.mobile]: {
      marginLeft: 0,
    },
  })
)



// WEBPACK FOOTER //
// ./src/components/Form/FormFields/FieldParts/InputFeedback/index.js